import { render, staticRenderFns } from "./ReservationRequests.vue?vue&type=template&id=54c0ecea&scoped=true&"
import script from "./ReservationRequests.vue?vue&type=script&lang=js&"
export * from "./ReservationRequests.vue?vue&type=script&lang=js&"
import style0 from "./ReservationRequests.vue?vue&type=style&index=0&id=54c0ecea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c0ecea",
  null
  
)

export default component.exports